import React from 'react';

const CollapseIcon = ({ color = "#465366", size = 18 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="2.5" width="17" height="13" rx="1.5" stroke={color}/>
      <rect x="10" y="4" width="6" height="10" rx="1" fill={color}/>
    </svg>
  );
};

export default CollapseIcon;
